import { useEffect, useRef } from "react";
import { NAV_LINKS, scrollToId } from "../config/site";
import { useScrollspy } from "../lib/scrollspy";

const HASHES = NAV_LINKS.map((l) => l.hash);

export const MobileTopicBar = () => {
  const active = useScrollspy(HASHES);
  const barRef = useRef(null);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;
    const chip = bar.querySelector(`[data-testid="topic-${active.slice(1)}"]`);
    if (chip) {
      bar.scrollTo({ left: chip.offsetLeft - bar.clientWidth / 2 + chip.clientWidth / 2, behavior: "smooth" });
    }
  }, [active]);

  return (
    <nav
      data-testid="mobile-topic-bar"
      aria-label="Navegação por tópicos"
      className="glass fixed inset-x-0 bottom-0 z-50 border-t border-white/10 lg:hidden"
    >
      <ul ref={barRef} className="flex gap-2 overflow-x-auto px-4 py-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {NAV_LINKS.map((l) => {
          const isActive = active === l.hash;
          return (
            <li key={l.hash} className="shrink-0">
              <button
                type="button"
                onClick={() => scrollToId(l.hash)}
                data-testid={`topic-${l.hash.slice(1)}`}
                aria-current={isActive ? "true" : undefined}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-[11px] font-semibold transition-all duration-300 ${
                  isActive
                    ? "bg-gb-silver text-gb-black shadow-[0_6px_20px_-8px_rgba(199,205,214,0.6)]"
                    : "border border-white/10 text-gb-gray"
                }`}
              >
                {l.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
